import { useCallback, useEffect, useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import type { InputRef } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { ColumnType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import { ClaimDataType } from "../../types/TableTypes";

//const mobileExpand =

export default function TableWithCollapse(props) {
  const {
    columns,
    data,
    onRowClick = null,
    expandable = false,
    rowSelection = null,
    isSearchTable,
    hideCol,
    pagination = null,
    handleChange = null,
    isRequestPage = false,
  } = props;
  const searchInput = useRef<InputRef>(null);
  const [columnRef, setColumnRef] = useState(columns);

  const dataByOrder =
    data?.length &&
    data.sort((a: ClaimDataType, b: ClaimDataType) => {
      const statusSeqA = a.statusSeq ?? 7;
      const statusSeqB = b.statusSeq ?? 7;
      const submissionDateA = new Date(
        a.SUBMISSION_DATE ? a.SUBMISSION_DATE : "01-Jan-1900"
      );
      const submissionDateB = new Date(
        b.SUBMISSION_DATE ? b.SUBMISSION_DATE : "01-Jan-1900"
      );
      const startDateA = new Date(a.startDate ? a.startDate : "01-Jan-1900");
      const startDateB = new Date(b.startDate ? b.startDate : "01-Jan-1900");

      if (isRequestPage) {
        if (statusSeqA < statusSeqB) {
          return -1;
        } else if (statusSeqA > statusSeqB) {
          return 1;
        } else if (startDateA < startDateB) {
          return -1;
        } else if (startDateA < startDateB) {
          return 1;
        } else {
          return 1;
        }
      } else {
        if (submissionDateA < submissionDateB) {
          return -1;
        } else if (submissionDateA > submissionDateB) {
          return 1;
        } else if (startDateA < startDateB) {
          return -1;
        } else if (startDateA > startDateB) {
          return 1;
        } else {
          return 1;
        }
      }
    });

  const handleSearch = (
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: string
  ) => {
    confirm();
    //setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
  };

  const getColumnSearchProps = useCallback(
    (dataIndex: string): ColumnType<any> => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close,
      }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(confirm, dataIndex)}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm({ closeDropdown: true });
              }}
              icon={<SearchOutlined />}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters);
                confirm({ closeDropdown: true });
              }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()
          .includes((value as string).toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    }),
    []
  );

  useEffect(() => {
    if (isSearchTable && columns) {
      let cols: ColumnType<any>[] = [];
      for (const col of columns) {
        //check hideCol
        if ((hideCol as string[]).includes(col.key)) continue;
        if (isSearchTable[col.key]) {
          cols.push({ ...col, ...getColumnSearchProps(col.key) });
        } else {
          cols.push(col);
        }
      }
      setColumnRef(cols);
    }
  }, [columns, isSearchTable, getColumnSearchProps, hideCol]);

  const tableC = (
    <Table
      columns={columnRef}
      expandable={expandable}
      dataSource={dataByOrder}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            if (onRowClick) onRowClick(record, rowIndex);
          },
        };
      }}
      rowSelection={rowSelection}
      pagination={pagination}
      onChange={handleChange}
    />
  );
  return tableC;
}
//On Auth fetch total num of pending approve / endorse request
//e.g. endorser_num
